import { StyleSheet, Text, View } from "react-native";

import { fullDisclaimerFor } from "@aucash/types/compliance";

import { colors, fonts, radius, space } from "./theme";

// Binding copy. The canonical wording lives in @aucash/types/compliance
// (verbatim from validation-plan §3.2, the "lawyer-substitute" playbook) so the
// app and the API's emails can never drift apart — do NOT inline or paraphrase
// it here. Drift from this exact text is a regulatory kill-threat, not a style
// nit (see CLAUDE.md → Regulatory guardrails). The full block renders at the
// TOP of every result, before any number (§3.2 placement rule). Each calculator
// passes its `product` so the block names the right product + regulator.

export { SHORT_DISCLAIMER, FULL_DISCLAIMER } from "@aucash/types/compliance";

/** Full disclaimer block — result-page header, above the first number. */
export function DisclaimerBlock({
  product = "au08",
}: {
  product?: "au08" | "au06" | "au13";
} = {}): JSX.Element {
  return (
    <View style={styles.block}>
      <Text style={styles.text}>{fullDisclaimerFor(product)}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  block: {
    backgroundColor: colors.sand,
    borderWidth: 1,
    borderColor: colors.line,
    borderRadius: radius.md,
    padding: space.lg,
  },
  text: {
    fontFamily: fonts.body,
    fontSize: 12,
    lineHeight: 18,
    color: colors.inkSoft,
  },
});
